// Mount Splide JS
import Splide from "/modules/splide/splide.min.js";
if (typeof window !== "undefined") {
  window.Splide = Splide;
}

// Contact Form 7 validation messages
document.addEventListener('DOMContentLoaded', function () {
	document.body.classList.add('ready');

	// Get all Contact Form 7 form controls inputs, selects, etc.
	const formControls = document.querySelectorAll('.wpcf7-form-control');

	// Loop through each form control
	formControls.forEach(function (field) {
		['click', 'input', 'change'].forEach(function (eventType) {
			field.addEventListener(eventType, function () {
				const wrapper = field.closest('.wpcf7-form-control-wrap');
				if (!wrapper) return;
				const tip = wrapper.querySelector('.wpcf7-not-valid-tip');
				if (tip) {
					tip.style.transition = 'opacity 0.3s ease';
					tip.style.opacity = '0';
					setTimeout(() => {
						tip.style.display = 'none';
					}, 300);
				}
			});
		});
	});
});